"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsVkError = checkIsVkError;
exports.checkErrorIsNetwork = checkErrorIsNetwork;
exports.checkErrorIsSoftApiError = checkErrorIsSoftApiError;
exports.exponentialBackoffForApi = exponentialBackoffForApi;
exports.exponentialBackoffAnyError = exponentialBackoffAnyError;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _VkError = require("./VkError");

var _exponentialBackoff = require("exponential-backoff");

var _const = require("./const");

function checkIsVkError(e) {
  return e instanceof _VkError.VkError;
}

function checkErrorIsNetwork(e) {
  return e.type === _VkError.VkErrorTypes.NETWORK_ERROR;
}

function checkErrorIsSoftApiError(e) {
  return e.type === _VkError.VkErrorTypes.API_ERROR && _const.SOFT_ERROR_CODES.includes(e.code);
}
/**
 * @param fn
 * @param onError если вернет true но будет повтор запроса если false то не будет
 * undefined -- будет повтор запроса если это ошибка сети или лоайтовый код ошибки
 * если undefined то будет использована стандартная логика
 */


function exponentialBackoffForApi(_x, _x2) {
  return _exponentialBackoffForApi.apply(this, arguments);
}

function _exponentialBackoffForApi() {
  _exponentialBackoffForApi = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(fn, onError) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _exponentialBackoff.backOff)(fn, {
              delayFirstAttempt: false,
              jitter: 'full',
              maxDelay: 10000,
              numOfAttempts: 6,
              startingDelay: 500,
              timeMultiple: 2,
              retry: function retry(e) {
                if (onError) {
                  var res = onError(e);

                  if (res !== undefined) {
                    return res;
                  }
                }

                if (checkIsVkError(e)) {
                  return checkErrorIsNetwork(e) || checkErrorIsSoftApiError(e);
                } else {
                  return false;
                }
              }
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _exponentialBackoffForApi.apply(this, arguments);
}

function exponentialBackoffAnyError(_x3, _x4) {
  return _exponentialBackoffAnyError.apply(this, arguments);
}

function _exponentialBackoffAnyError() {
  _exponentialBackoffAnyError = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fn, onError) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _exponentialBackoff.backOff)(fn, {
              delayFirstAttempt: false,
              jitter: 'full',
              maxDelay: 10000,
              numOfAttempts: 10,
              startingDelay: 500,
              timeMultiple: 2,
              retry: function retry(e) {
                return !(onError && onError(e));
              }
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _exponentialBackoffAnyError.apply(this, arguments);
}